<div class="media p-3">
    <div class="mr-3 rounded-circle">
        <one-avatar size="38" [imageUrl]="discussion.createUser.avatarUrl"></one-avatar>
    </div>
    <div class="media-body">
        <div class="editing" *ngIf="isEdit || isAddNew">
            <mat-form-field appearance="outline" class="full">
                <textarea matInput placeholder="Nhập bình luận của bạn" rows="5" [formControl]="discussionControl" (click)="onAddDiscussion()"></textarea>
            </mat-form-field>
            <div class="actions" *ngIf="isTexting">
                <button mat-button (click)="onCancelDiscussion()">Hủy</button>
                <button mat-raised-button color="warn" (click)="onPost()" [disabled]="!discussionControl.value" >Đăng</button>
            </div>
        </div>
        <div class="reading" *ngIf="!isEdit && !isAddNew">
            <h4>{{discussion.createUser.fullName}} - <small><i>{{discussion.postedDate}}</i></small></h4>
            <p *ngIf="readOnly == false">{{discussion.content}}</p>
            <div *ngIf="readOnly" class="read-only-msg" [innerHTML]="formattedContent"></div>
            <div class="options" *ngIf="isOwner">
                <span class="option" (click)="onEdit()">Chỉnh sửa</span>
                <span class="option" (click)="onDelete()">Xóa</span>
            </div>
        </div>
    </div>
</div>
